import React, { useEffect, useMemo, useState } from 'react';
import { useNotification } from '../../../../components/framework/NotificationContext';
import { getAuditLog } from '../../../../services/emailAuditService';

const AuditLogPanel = () => {
    const { error: notifyError } = useNotification();
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [actionFilter, setActionFilter] = useState('all');

    useEffect(() => {
        setLoading(true);
        getAuditLog()
            .then((data) => setEntries(data?.content || data || []))
            .catch((err) => notifyError(err.message || 'Failed to load audit log'))
            .finally(() => setLoading(false));
    }, []);

    const actions = useMemo(() => ['all', ...new Set(entries.map((e) => e.action).filter(Boolean))], [entries]);

    const filtered = useMemo(() => {
        const term = search.toLowerCase().trim();
        return entries.filter((e) => {
            const matchesSearch = !term || e.action?.toLowerCase().includes(term) || e.targetType?.toLowerCase().includes(term) || e.adminName?.toLowerCase().includes(term);
            const matchesAction = actionFilter === 'all' || e.action === actionFilter;
            return matchesSearch && matchesAction;
        });
    }, [entries, search, actionFilter]);

    return (
        <div className="admin-card">
            <h5 className="mb-3"><i className="bi bi-shield-check me-2"></i>Audit Log</h5>
            <div className="d-flex gap-2 mb-3 flex-wrap">
                <input className="form-control form-control-sm" style={{ maxWidth: '260px' }} placeholder="Search…" value={search} onChange={(e) => setSearch(e.target.value)} />
                <select className="form-select form-select-sm" style={{ maxWidth: '220px' }} value={actionFilter} onChange={(e) => setActionFilter(e.target.value)}>
                    {actions.map((a) => <option key={a} value={a}>{a}</option>)}
                </select>
            </div>
            {loading ? (
                <div className="text-center py-4"><div className="spinner-border text-primary" role="status"></div></div>
            ) : (
                <div className="table-responsive">
                    <table className="admin-table">
                        <thead>
                            <tr><th>Timestamp</th><th>Admin</th><th>Action</th><th>Target</th><th>Outcome</th><th>IP</th></tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan="6" className="text-center text-muted py-4">No audit entries found.</td></tr>
                            ) : filtered.map((e) => (
                                <tr key={e.id}>
                                    <td className="mono-font" style={{ fontSize: '0.85rem' }}>{e.createdAt ? new Date(e.createdAt).toLocaleString() : '—'}</td>
                                    <td>{e.adminName || e.adminUserId || 'system'}</td>
                                    <td>{e.action}</td>
                                    <td>{e.targetType} {e.targetId ? `#${e.targetId}` : ''}</td>
                                    <td>
                                        <span className={`badge ${e.outcome === 'SUCCESS' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                            {e.outcome}
                                        </span>
                                    </td>
                                    <td className="mono-font" style={{ fontSize: '0.8rem' }}>{e.ipAddress || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AuditLogPanel;
